import axios from "axios";

const api = axios.create({
    baseURL: "https://n8n.condutorlegal.com.br/webhook",
    headers: {
        "x-api-key": '136DBA15429AE6535AF879B978CB4'
    }
});

export async function SendConversion(order_id, order_total_items, order_status, order_payment_method, order_payment_amount) {
    var querystring = require('querystring');

    let email_user = localStorage.getItem("CLLogin");

    let data = querystring.stringify({
        email: email_user,
        order_id,
        order_total_items,
        order_status,
        order_payment_method,
        order_payment_amount
    });

    let responseServer = {};
    await api.post('send-event-closed-order', data)
    .then(response => {
        responseServer = response.data;
    })
    .catch(error => {
        responseServer = error.response;
    });
    return responseServer;
}